import { isBrokenDatabase } from '@databases/utils/database/utils';
import { selectDatabaseByContentIdOptional } from '@databases/utils/redux/databases/selectors';

import { selectDatabaseDraftByContentId } from '../changesets/selectors';
import { type DefaultRootState } from '../redux';

// Memoize selectDatabase function by scope to enable caching in getBacklinkEntries()
const selectDatabaseDraft: Record<string, typeof selectDatabaseByContentIdOptional> = {};
export function getSelectDatabaseDraft(
  includeDeleted: boolean
): typeof selectDatabaseByContentIdOptional {
  const key = `main-${includeDeleted}`;
  if (!selectDatabaseDraft[key]) {
    selectDatabaseDraft[key] = (state, { contentId }) => {
      // Check if target database is present, return undefined in case it doesn't rather than throwing an exception
      const targetDatabase = selectDatabaseByContentIdOptional(state, { contentId });
      return targetDatabase && !isBrokenDatabase(targetDatabase)
        ? selectDatabaseDraftByContentId(state as DefaultRootState, {
            contentId: targetDatabase.contentId,
            includeDeleted,
          })
        : undefined;
    };
  }
  return selectDatabaseDraft[key];
}
